import React from 'react'

const Contest = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M20.5999 2.90002C20.3835 2.77416 20.1163 2.77416 19.8999 2.90002C19.062 3.36492 18.1183 3.606 17.16 3.6C15.7588 3.63098 14.404 3.09773 13.4 2.12002C12.2408 0.985406 10.6736 0.365438 9.05198 0.400031C7.746 0.388734 6.46912 0.785906 5.4 1.53605V1.2C5.4 0.537281 4.86277 0 4.2 0C3.53723 0 3 0.537234 3 1.2V22.8C3 23.4627 3.53723 24 4.2 24C4.86272 24 5.4 23.4628 5.4 22.8V12.4C5.53256 12.3876 5.65884 12.3376 5.76398 12.256C6.71564 11.5552 7.87022 11.1844 9.05198 11.2C10.4557 11.1677 11.8134 11.701 12.82 12.68C13.9769 13.8129 15.541 14.4328 17.16 14.4C18.4007 14.4144 19.6177 14.0594 20.656 13.38C20.8782 13.226 21.0076 12.9702 21 12.6999V3.6C21.0025 3.31163 20.8497 3.0442 20.5999 2.90002Z" fill="#0D1536" fillOpacity="0.8"/>
    </svg>
    
)

export default Contest
